// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/banner-mid-page-full-width/banner-mid-page-full-width.component.scss
// module id = 432
// module chunks = 0